//@ts-check
import React from 'react';
import Icon from '../../../core/Icon';
var style = {
  textAlign: 'center',
  top: 'calc(50% - 10px)',
  right: 2,
  position: 'absolute',
  pointerEvents: 'none',
  fontSize: '1.2em'
};

var DropdownIndicatorIcon = function DropdownIndicatorIcon(props) {
  return React.createElement(Icon, {
    type: "down-filled",
    buttonSize: "small",
    style: style,
    className: props.className
  });
};

export default DropdownIndicatorIcon;